import { Swiper, SwiperSlide } from 'swiper/vue'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('Swiper', Swiper)
  nuxtApp.vueApp.component('SwiperSlide', SwiperSlide)
})
